import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth is cookie-based (httpOnly). Always send cookies; never store tokens in JS.
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config || {};
    const url = original.url || "";
    const isAuthPath =
      url.includes("/auth/login") ||
      url.includes("/auth/refresh") ||
      url.includes("/auth/me") ||
      url.includes("/auth/logout");
    if (err.response?.status === 401 && !original._retry && !isAuthPath) {
      original._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch (e) {
        // Refresh failed; let AuthContext/ProtectedRoute handle redirect.
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
